
/**
 * Function that controls the search field for any available items
 * 
 * @param {HTMLInputElement} searchInput the input
 * @param {HTMLElement} resultsContainer the parent container of each available item
 */
export const searchAvailableItems = (searchInput: HTMLInputElement, resultsContainer: HTMLElement) => {
  if ( !searchInput ) return;
  const searchContainer = document.querySelector('.aafp_text-field') as HTMLElement;
  const clearButton = document.querySelector('.aafp_clear-search') as HTMLElement;

  searchInput.addEventListener('keyup', event => {
    searchAvailable(searchInput, resultsContainer);
  });  

  searchInput.addEventListener('focus', () => {
    clearButton.style.display = 'block';
  });

  document.addEventListener('click', ({target}: MouseEvent): void => {
    if(searchContainer !== target && !searchContainer.contains(target as Node) && searchInput.value === '') {
      clearButton.style.display = 'none';
    }
  });

  clearButton.addEventListener('click', () => {
    clearButton.style.display = 'none';
    searchClear(searchInput, resultsContainer);
  });
}

/**
 * Function that searches the available items
 * 
 * @param {HTMLInputElement} searchInput the input
 * @param {HTMLElement} resultsContainer the parent container of each available item
 */
const searchAvailable = (searchInput: HTMLInputElement, resultsContainer: HTMLElement) => {
  const filterTerm = searchInput.value.toUpperCase();
  const innerResultsElem = resultsContainer.getElementsByTagName('span');

  Array.from(innerResultsElem).forEach((elem) => {
    const txtValue = elem.textContent!;
    const displayStyle = txtValue.toUpperCase().includes(filterTerm) ? 'flex' : 'none';
    elem.parentElement!.style.setProperty('display', displayStyle, 'important');
  });
}

/**
 * Function that clears a search input
 * 
 * @param {HTMLInputElement} searchInput the input
 * @param {HTMLElement} resultsCon the parent container of each available item
 */
export const searchClear = (searchInput: HTMLInputElement, resultsCon: HTMLElement) => {
  searchInput.value = '';

  const spans = resultsCon.getElementsByTagName('span');
  for (let i = 0; i < spans.length; i++) {
    spans[i].parentElement!.style.display = 'flex';
  }  
}